import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { SelectablePeriod } from 'app/modules/user/dashboard/dashboard.types';
import moment from 'moment';
import { ApexAxisChartSeries, ApexOptions, ChartComponent } from 'ng-apexcharts';

@Component({
    selector: 'app-value-with-graph',
    templateUrl: './value-with-graph.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./value-with-graph.component.scss']
})
export class ValueWithGraphComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() chartOptions?: ApexOptions;
    @Input() chartColor: string;
    @Input() chartSeries: ApexAxisChartSeries;
    @Input() chartLabels?: string[];
    @Input() currency?: string;
    @Input() titleKey: string;
    @Input() totalValue: string;
    @Input() selectedPeriod: SelectablePeriod;
    @Input() selectablePeriods: SelectablePeriod[];
    @Output() readonly onPeriodChanged: EventEmitter<SelectablePeriod> = new EventEmitter<SelectablePeriod>();

    @ViewChild('lineGraph') graph: ChartComponent;

    labelType: "datetime" | "category";
    viewInit: boolean;
    finalTotalValue: string;

    constructor(
        private currencyPipe: CurrencyPipe,
        private decimalPipe: DecimalPipe,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
    }
    ngAfterViewInit(): void {
        //Find a better way. If the chart renders immediately, it fails to set the correct width.
        /* setTimeout(() => {
            this.viewInit = true;
            if (this.chartSeries) {
                this.initChartOptions();
            }
        }, 200); */
    }

    ngOnChanges() {
        if (!this.chartSeries) {
            return;
        }

        if (this.chartOptions) {
            this.chartOptions.series = this.chartSeries ?? [];
            this.chartOptions.xaxis.categories = this.chartLabels ?? [];
        }

        if (this.chartSeries?.length && this.chartSeries[0].data?.length) {
            this.labelType = (!isNaN(Date.parse((this.chartSeries[0].data[0] as { x: any, y: any }).x)) ? 'datetime' : 'category')
        } else {
            this.labelType = 'datetime';
        }

        if (this.chartSeries?.length && this.chartSeries[0].data.length && !this.totalValue) {
            let totalValue: number = this.chartSeries[0].data?.map(row => row.y).reduce((sum, x) => sum + x) ?? 0;
            this.finalTotalValue = this.currency ?
                this.currencyPipe.transform(totalValue, this.currency, 'symbol', '1.2-2') :
                this.decimalPipe.transform(totalValue, '1.0-0');
        } else if (this.totalValue !== undefined) {
            this.finalTotalValue = this.totalValue;
        }

        if (this.labelType === 'category' && !this.chartLabels?.length) {
            this.chartLabels = this.chartSeries[0].data.map(row => row.x);
        }

        if (!this.selectablePeriods?.length) {
            //this.initChartOptions();
        }
    }

    ngOnInit(): void {
        this.initChartOptions();
    }

    initChartOptions(): void {
        this.chartOptions = {
            chart: {
                animations: {
                    speed: 400,
                    enabled: true
                },
                fontFamily: 'inherit',
                foreColor: 'inherit',
                height: '100%',
                type: 'area',
                sparkline: {
                    enabled: true
                },
            },
            colors: [this.chartColor ?? '#DDD'],
            fill: {
                colors: [this.chartColor ?? '#DDD'],
                opacity: 0.5
            },
            stroke: {
                curve: 'smooth'
            },
            series: this.chartSeries ?? [],
            tooltip: {
                x: {
                    formatter: (val, opts: any) => {
                        if (opts.dataPointIndex === undefined) {
                            return val.toString();
                        }
                        let currentTime = moment(this.chartSeries[0].data[opts.dataPointIndex]['x']).unix() * 1000;
                        if (this.chartSeries[0].data.length >= opts.dataPointIndex) {
                            let data = this.chartSeries[0].data[opts.dataPointIndex + 1];
                            let nextTime = moment(data ? data['x'] : 0).unix() * 1000;
                            //If the difference between currentTime and nextTime is larger than a day, format the date as a range (minus one day)
                            if (nextTime - currentTime > 86400000) {
                                return moment(currentTime).format('DD MMM YYYY') + ' - ' + moment(nextTime - 86400000).format('DD MMM YYYY');
                            }
                        }
                        return moment(val).format('DD MMM YYYY');
                    },
                },
                theme: 'dark',
              },
            xaxis: {
                type: this.labelType,
                categories: this.chartLabels ?? [],
                //max: this.labelType === 'datetime' ? moment().subtract(6, "days").unix() : undefined,
            },
            yaxis: {
                max(max) {
                    if (max > 0) {
                        return max * 1.05;
                    }
                    return undefined;
                },
                labels: {
                    formatter: (val) => {
                        return this.currency ? this.currencyPipe.transform(val, this.currency, 'symbol', '1.2-2') : this.decimalPipe.transform(val, '1.0-0');
                    }
                }
            }
        };
        this._changeDetectorRef.markForCheck();
    }

    periodChanged(period: SelectablePeriod): void {
        this.onPeriodChanged.emit(period);
    }
}
